/**
 * Principal risk LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update pair setting request.
 */
export interface UpdateAccountPairSettingRequest {
  id: number;
  /**
   * Formula: 1 = 0.1 BPS = 0.001% = 0.00001.
   */
  takeProfit: number;
  /**
   * Formula: 1 = 0.1 BPS = 0.001% = 0.00001.
   */
  stopLoss: number;
  /**
   * In milliseconds
   */
  maxRiskTime: number;
  minExecVolume: number;
  maxExecVolume: number;
}
